import React from 'react';
import Button from 'react-bootstrap/Button';
import FacePreview from './FacePreview';

// Face sign-in for a form that has its OWN "Operator PIN" box (the laser Add Sheet popup), driven
// by useFacePin. pinPrompt has its own panel with a countdown; here nothing resolves by itself: a
// match only stands in for the PIN when the operator presses the form's own button.
// Renders nothing when face is off for this form.
export default function FaceSignInStrip({ state, onNotMe, onTryAgain }) {
  const { phase, stream, match, message } = state;
  if (phase === 'off' || phase === 'checking') return null;

  if (phase === 'fallback' || phase === 'cancelled') {
    return (
      <div style={styles.fallback} data-testid="face-strip-fallback">
        {phase === 'fallback' && <span>{message} </span>}
        <Button variant="link" size="sm" style={styles.link} onClick={onTryAgain}>
          Try face again
        </Button>
      </div>
    );
  }

  return (
    <div style={styles.box} data-testid="face-strip">
      {stream && <FacePreview stream={stream} width={150} testId="face-strip-preview" />}
      {phase === 'looking' && <div style={styles.status} role="status">Looking for you… (or type your PIN)</div>}
      {phase === 'matched' && match && (
        <div style={styles.matchedCol}>
          <div style={styles.matchedName} role="status">✓ {match.name}</div>
          <div style={styles.hint}>Signed in by face. No PIN needed.</div>
          <Button variant="outline-secondary" size="sm" onClick={onNotMe} style={{ marginTop: 4 }}>
            Not you? Type PIN
          </Button>
        </div>
      )}
    </div>
  );
}

const styles = {
  box: {
    display: 'flex', alignItems: 'center', gap: 12, padding: 8, marginBottom: 10,
    border: '1px solid var(--jq-border-medium, #dee2e6)', borderRadius: 6,
    background: 'var(--jq-bg-subtle, #f8f9fa)',
  },
  status: { fontSize: '0.9rem', color: 'var(--jq-text-muted, #6c757d)' },
  matchedCol: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' },
  matchedName: { fontSize: '1.3rem', fontWeight: 700, color: '#198754', lineHeight: 1.2 },
  hint: { fontSize: '0.8rem', color: 'var(--jq-text-muted, #6c757d)' },
  fallback: { fontSize: '0.85rem', color: '#6c757d', marginBottom: 8 },
  link: { padding: 0, fontSize: '0.85rem', verticalAlign: 'baseline' },
};
